module.exports = __webpack_public_path__ + "img/warning-red.efa8eb81.svg";